module.exports = __webpack_public_path__ + "static/img/big1.3f4a0d0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/big1.jpg
// module id = 6EBn
// module chunks = 1